import React, { useEffect, useState } from "react";
import { Accordion, Button, Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";

//
import { DEFAULT_PLANET_FIELDS, generateGMTOffsets } from "helpers/constants";

import Planet from "./Components/Planet";
import PlanetPop from "../Modals/PlanetPop";
import Checkbox from "components/Checkbox";
import NewPlanetPopup from "../Modals/NewPlanetPopup";
import { generateRandomId } from "helpers/common";
import { ReactComponent as ExchangeIcn } from "Assets/icons/exchange-icon.svg";
import { ReactComponent as CalendarIcn } from "Assets/icons/calendar-icon.svg";
import WorkBookCalendar from "./Components/Calendar";
import actions from "store/actions";
import { updateByName, updateCalendar } from "store/workbook/workbookSlice";
import { ChartLineIcon, PencilIcon } from "Assets/icons";
import TimezoneSelect from "./Components/TimezoneSelect";

const TradingSidebar = ({ maxDatePast, maxDateFuture }) => {
  const dispatch = useDispatch();

  const { workbook, calendar } = useSelector((state) => state.workbook);

  const [planetPopup, setPlanetPopup] = useState({
    isOpen: false,
    planetData: "",
  });
  const [showNewPlanetPopup, setShowNewPlanetPopup] = useState(false);

  // useEffect(() => {
  //   if(!workbook.graph?.length) {
  //     return;
  //   }
  //   let firstTimestampOfChart = workbook.graph[0].timestamp;
  //   handleChangeCalendarProps("activeDate", firstTimestampOfChart);
  // }, [workbook.graph]);

  const handlePlanetPop = (planet) => () => {
    setPlanetPopup((prevState) => ({
      isOpen: !prevState.isOpen,
      planetData: planet
    }))
  };

  const handleChange = (name) => (evt) => {
    dispatch(updateByName({
      name,
      value: evt.target.value
    }));
  };

  const handlePlanetChange = (planetData) => {
    let planetsCopy = [...workbook.planets];
    let editPlanetIdx = planetsCopy.findIndex(planet => planet.key === planetData.key);

    if (editPlanetIdx !== -1) {
      // edit existing planet
      let editPlanet = planetsCopy[editPlanetIdx];
      planetsCopy[editPlanetIdx] = { ...editPlanet, ...planetData };
    } else {
      // add new planet
      planetsCopy.push(planetData);
    }

    // save planets
    handleChange("planets")({
      target: {
        value: planetsCopy,
      },
    });
  };

  const toggleEnablePlanet = (planetKey, isEnabled) => {
    let planetsCopy = [...workbook.planets];
    let editPlanetIdx = planetsCopy.findIndex(planet => planet.key === planetKey);

    if (editPlanetIdx !== -1) {
      let editPlanet = { ...planetsCopy[editPlanetIdx], enabled: isEnabled };
      planetsCopy[editPlanetIdx] = editPlanet;

      handleChange("planets")({
        target: {
          value: planetsCopy,
        },
      });
    }
  };

  const handleAddPlanet = (planetName) => {
    handlePlanetPop({
      ...DEFAULT_PLANET_FIELDS,
      name: planetName,
      key: `${planetName}_${generateRandomId()}`,
      enabled: true,
    })();
  }

  const handleDeletePlanet = (planetKey) => {
    let planetsCopy = [...workbook.planets];
    let delPlanetIdx = planetsCopy.findIndex(planet => planet.key === planetKey);

    if (delPlanetIdx !== -1) {
      planetsCopy.splice(delPlanetIdx, 1);

      handleChange("planets")({
        target: {
          value: planetsCopy,
        },
      });
    }
  }

  const handleChangeCalendarProps = (key, value) => {
    const calendarCopy = { ...calendar };
    calendarCopy[key] = value;
    dispatch(updateCalendar(calendarCopy))
  }

  const handleChangeTrendlineProps = (key, value) => {
    const clonedData = { ...(workbook?.trendLineConfig || {}) };
    clonedData[key] = value;
    handleChange("trendLineConfig")({
      target: {
        value: clonedData
      }
    })
  }

    const handleHelioChangeTrendlineProps = (key, value) => {
    const clonedData = { ...(workbook?.helioCentrictrendLineConfig || {}) };
    clonedData[key] = value;
    handleChange("helioCentrictrendLineConfig")({
      target: {
        value: clonedData
      }
    })
  }

  return (
    <>
      <NewPlanetPopup
        showPopup={showNewPlanetPopup}
        setShowPopup={setShowNewPlanetPopup}
        onChoosePlanet={handleAddPlanet}
      />
      <PlanetPop
        planetPopup={planetPopup.isOpen}
        data={planetPopup.planetData}
        onChange={handlePlanetChange}
        handlePlanetPop={handlePlanetPop}
      />

      <div className="cardCstm py-2 bg-white h-100">
        <Accordion>
          <ul className="list-unstyled ps-0 mb-0">
            <li className="py-1">
              <ul className="list-unstyled  mb-0 ps-3">
                <li className="py-2 px-1 border-bottom">
                  <div className="d-flex align-items-center">
                    <span className="icn me-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="12"
                        height="14"
                        viewBox="0 0 12 14"
                        fill="none"
                      >
                        <path
                          opacity="0.4"
                          d="M5.99445 11.4143L1.66662 13.576C1.3398 13.7534 0.932114 13.635 0.749315 13.3095C0.695928 13.2072 0.667697 13.0934 0.666992 12.9779V8.13916C0.666992 8.61888 0.937481 8.91501 1.64898 9.24667L5.99445 11.4143Z"
                          fill="url(#paint0_linear_1_687)"
                        />
                        <path
                          d="M8.04663 0.333252C9.85185 0.333252 11.316 1.04395 11.3337 2.86216V12.9778C11.3329 13.0915 11.3047 13.2033 11.2513 13.3035C11.1656 13.467 11.0176 13.5884 10.8413 13.6398C10.665 13.6911 10.4755 13.6681 10.3164 13.576L5.99445 11.4143L1.64898 9.24663C0.937481 8.91497 0.666992 8.61884 0.666992 8.13912V2.86216C0.666992 1.04395 2.13116 0.333252 3.9305 0.333252H8.04663ZM8.49941 4.36056H3.4836C3.19457 4.36056 2.96027 4.59655 2.96027 4.88766C2.96027 5.17877 3.19457 5.41477 3.4836 5.41477H8.49941C8.78844 5.41477 9.02274 5.17877 9.02274 4.88766C9.02274 4.59655 8.78844 4.36056 8.49941 4.36056Z"
                          fill="url(#paint1_linear_1_687)"
                        />
                        <defs>
                          <linearGradient
                            id="paint0_linear_1_687"
                            x1="3.33072"
                            y1="8.13916"
                            x2="3.33072"
                            y2="13.6584"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stopColor="#3A674A" />
                            <stop offset="1" stopColor="#0C3D1D" />
                          </linearGradient>
                          <linearGradient
                            id="paint1_linear_1_687"
                            x1="6.00033"
                            y1="0.333252"
                            x2="6.00033"
                            y2="13.6666"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stopColor="#3A674A" />
                            <stop offset="1" stopColor="#0C3D1D" />
                          </linearGradient>
                        </defs>
                      </svg>
                    </span>
                    <p className="m-0 themeClr">Properties</p>
                  </div>
                </li>

                <li className="py-2 px-2 border-bottom d-flex align-items-center justify-content-between gap-10">
                  <p className="m-0 text-muted">Tool Name</p>

                  <h6 className="m-0 fw-sbold">
                    <span className="icn me-2">
                      <PencilIcon />
                    </span>

                    <input
                      style={{ width: "140px" }}
                      value={workbook.toolName}
                      onChange={handleChange("toolName")}
                    />
                  </h6>
                </li>

                <li className="py-2 px-2 border-bottom d-flex align-items-center justify-content-between gap-10">
                  <p className="m-0 text-muted">Price Unit</p>

                  <h6 className="m-0 fw-sbold">
                    <span className="icn me-2">
                      <PencilIcon />
                    </span>

                    <input
                      type="number"
                      min={0}
                      style={{ width: "80px" }}
                      value={(workbook.useChartPriceUnit ? workbook.chartPriceUnit : workbook.priceUnit) || 100}
                      onChange={handleChange("priceUnit")}
                      disabled={workbook.useChartPriceUnit}
                    />
                  </h6>
                </li>

                <li className="py-2 px-2 border-bottom d-flex align-items-center justify-content-between gap-10">
                  <p className="m-0 text-muted">Use Chart Price Unit</p>

                  <Checkbox
                    checked={workbook.useChartPriceUnit}
                    onChange={handleChange("useChartPriceUnit")}
                  />
                </li>
                {/* <li className="py-2 px-2 border-bottom d-flex align-items-center justify-content-between gap-10">
                  <p className="m-0 text-muted">Stock Name:</p>

                  <p className="m-0">{workbook?.stock?.ticker_name}</p>
                </li> */}
              </ul>
            </li>

            <li className="py-1">
              <Accordion.Item eventKey="accordion-calendar" className="border-0">
                <Accordion.Header>
                  <span className="icn me-2">
                    <CalendarIcn />
                  </span>
                  Calendar
                </Accordion.Header>
                <Accordion.Body>
                  <WorkBookCalendar
                    handleChange={handleChangeCalendarProps}
                    data={calendar}
                    maxDatePast={maxDatePast}
                    maxDateFuture={maxDateFuture}
                  />
                </Accordion.Body>
              </Accordion.Item>
            </li>

            <li className="py-1">
              <Accordion.Item eventKey="accordion-planets" className="border-0">
                <Accordion.Header>
                  <span className="icn me-2">
                    <ChartLineIcon />
                  </span>
                  Planet
                </Accordion.Header>

                <Accordion.Body>
                  <div className="d-flex align-items-center w-100 justify-content-start">
                    <Button
                      onClick={() => {
                        setShowNewPlanetPopup(true);
                      }}
                      className="btn btn-sm d-flex gap-10 align-items-center"
                      variant="transparent"
                      style={{ color: "#265436" }}
                    >
                      <i className="fa fa-plus-square-o" aria-hidden="true"></i>
                      Add Planet
                    </Button>
                  </div>
                  <ul className="list-unstuyled ps-0 position-relative mb-0 border-start commonList">
                    {workbook?.planets?.length > 0 && workbook.planets.map((planet, i) => {
                      return (
                        <Planet
                          key={i}
                          data={planet}
                          toggleEnable={toggleEnablePlanet}
                          handlePlanetPop={handlePlanetPop(planet)}
                          handleDelete={handleDeletePlanet}
                        />
                      )
                    })}
                  </ul>
                </Accordion.Body>
              </Accordion.Item>
            </li>

            <li className="py-1">
              <Accordion.Item eventKey="accordion-gmtoffset" className="border-0">
                <Accordion.Header className="justify-content-between odd">
                  <div className="left d-flex align-items-center">
                    <span className="icn me-2">
                      <ChartLineIcon />
                    </span>
                    GMT Offset
                  </div>

                  <div className="right d-flex align-items-centr gap-10">
                    <p className="m-0 me-2">{workbook.gmtOffset}</p>
                  </div>
                </Accordion.Header>

                <Accordion.Body>
                  <TimezoneSelect
                    gmtOffset={workbook?.gmtOffset}
                    handleChange={handleChange}
                  />
                </Accordion.Body>
              </Accordion.Item>
            </li>

            <li className="py-1">
              <Accordion.Item eventKey="accordion-trendline-geo" className="border-0">
                <Accordion.Header className="justify-content-between odd">
                  <div className="left d-flex align-items-center">
                    <span className="icn me-2">
                      <ChartLineIcon />
                    </span>
                    Prediction Line
                  </div>
                </Accordion.Header>
                <Accordion.Body>
                  <ul className="list-unstyled  mb-0 p-0">
                    <li className="py-2 border-bottom d-flex align-items-center justify-content-between gap-10">
                      <p className="m-0 text-muted">Starting Position</p>

                      <h6 className="m-0 fw-sbold">
                        <Form.Select
                          aria-label="TrendLine Starting Position"
                          className="form-control"
                          onChange={(e) => {
                            handleChangeTrendlineProps("startingPosition", e.target.value);
                          }}
                          value={workbook?.trendLineConfig?.startingPosition}
                        >
                          <option value="high">High</option>
                          <option value="low">Low</option>
                        </Form.Select>
                      </h6>
                    </li>
                    <li className="py-2 border-bottom d-flex align-items-center justify-content-between gap-10">
                      <p className="m-0 text-muted">Trend Line Price Unit</p>

                      <h6 className="m-0 fw-sbold">
                        <span className="icn me-2">
                          <PencilIcon />
                        </span>

                        <input
                          type="number"
                          min={0}
                          style={{ width: "80px" }}
                          value={workbook.highestPriceChange}
                          onChange={handleChange("highestPriceChange")}
                        />
                      </h6>
                    </li>
                  </ul>
                </Accordion.Body>
              </Accordion.Item>
            </li>

            <li className="py-1">
            <Accordion.Item eventKey="accordion-trendline-helio" className="border-0">
              <Accordion.Header className="justify-content-between odd">
                <div className="left d-flex align-items-center">
                  <span className="icn me-2"><ChartLineIcon /></span>
                  Super Prediction Line
                </div>
              </Accordion.Header>
              <Accordion.Body>
                <ul className="list-unstyled mb-0 p-0">
                  <li className="py-2 border-bottom d-flex align-items-center justify-content-between gap-10">
                    <p className="m-0 text-muted">Starting Position</p>
                    <h6 className="m-0 fw-sbold">
                      <Form.Select
                        aria-label="Helio TrendLine Starting Position"
                        className="form-control"
                        onChange={(e) => handleHelioChangeTrendlineProps("startingPosition", e.target.value)}
                        value={
                          workbook?.helioCentrictrendLineConfig?.startingPosition ??
                          workbook?.helioCentrictrendLineConfig?.startingPosition ??
                          "high"
                        }
                      >
                        <option value="high">High</option>
                        <option value="low">Low</option>
                      </Form.Select>
                    </h6>
                  </li>
                  <li className="py-2 border-bottom d-flex align-items-center justify-content-between gap-10">
                    <p className="m-0 text-muted">Price Unit</p>
                    <h6 className="m-0 fw-sbold">
                      <span className="icn me-2"><PencilIcon /></span>
                      <input
                        type="number"
                        min={0}
                        style={{ width: "80px" }}
                        value={workbook?.highestHelioCentricPriceChange}
                        onChange={handleChange("highestHelioCentricPriceChange")}
                      />
                    </h6>
                  </li>
                </ul>
              </Accordion.Body>
            </Accordion.Item>
          </li>

          </ul>
        </Accordion>
      </div>
    </>
  );
};

export default React.memo(TradingSidebar);
